import {
  Alert,
  Box,
  Button,
  Card,
  Container,
  Group,
  List,
  SegmentedControl,
  SimpleGrid,
  Stack,
  Text,
  Title,
  rem,
} from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { useState } from 'react';
import segmentedControl from './SegmentedControl.module.css';

export function Upgrade({ user }) {
  const [billingFrequency, setBillingFrequency] = useState('annual');
  const priceLookupKey = `slides-generator_pro_${billingFrequency === 'annual' ? 'yearly' : 'monthly'}`;

  const handleUpgrade = async () => {
    window.open(
      `${window.location.origin}/checkout?price=${encodeURIComponent(priceLookupKey)}&email=${encodeURIComponent(user.email || '')}`,
      'popupWindow',
      'width=600,height=800,resizable,scrollbars'
    );
  };

  return (
    <Container size="lg" pos="relative" px="lg" py="xl">
      <Title order={1} fz={{ sm: rem(30), md: rem(45) }} fw={900} ta="center" mb="xl">
        Get access to all web slides features
      </Title>

      <Stack align="center" justify="center" gap="md" mt="md" mb="lg">
        <SegmentedControl
          value={billingFrequency}
          radius="xl"
          size="md"
          data={[
            { label: 'Annual billing', value: 'annual' },
            { label: 'Monthly billing', value: 'monthly' },
          ]}
          classNames={segmentedControl}
          onChange={setBillingFrequency}
          mb="md"
        />
      </Stack>

      <Alert
        variant="light"
        color="blue"
        title="Save 20% when you subscribe yearly"
        styles={{ title: { fontSize: 20 } }}
        mb="xl"
      />

      <SimpleGrid cols={1} spacing="md">
        <Card shadow="sm" radius={0} p="lg">
          <Box>
            <Title mb="sm" c="orange" fz={rem(40)}>
              Slides Generator Pro
            </Title>
            <Group align="baseline" gap="0" mb="md">
              <Text size="xl" c="gray">
                US$
              </Text>
              {
                <Title fw="800" size={rem(40)} mx="3px">
                  {billingFrequency === 'annual' ? '8' : '10'}
                </Title>
              }
              <Text c="gray"> / user / month</Text>
            </Group>
            <Text mb="md">
              {billingFrequency === 'annual' ? 'US$96 billed annually' : 'Billed monthly'}
            </Text>

            <Text mb="md" fw="800" fz={rem(17)}>
              What's included:
            </Text>
            <List spacing="md" mb="xl" center icon={<IconCheck color="green" size={16} />}>
              <List.Item>
                <Text fz={rem(17)}>Generate unlimited slides per presentation.</Text>
              </List.Item>
              <List.Item>
                <Text fz={rem(17)}>Presentations stored indefinitely.</Text>
              </List.Item>
              <List.Item>
                <Text fz={rem(17)}>
                  Remove Slides Generator branding from presentations and replace with your own.
                </Text>
              </List.Item>
              <List.Item>
                <Text fz={rem(17)}>Cancel anytime.</Text>
              </List.Item>
            </List>
          </Box>

          <Stack justify="flex-end" h="100%">
            <Button id="team" size="lg" bg="#FF2A77" onClick={handleUpgrade}>
              Upgrade
            </Button>
          </Stack>
        </Card>
      </SimpleGrid>
    </Container>
  );
}
